import snsAxiosClient from '../common/http/http-sns';
import formatString from '../utils/formatString';
import { get } from 'lodash';

function updateDeliveryInstructionsService(environmentVariables, user, deliveryInstructions) {
  const options = {
    headers: {
      ...get(environmentVariables, 'API_HEADERS_PATCH_V1'),
      Authorization: `Bearer ${get(user, 'authToken')}`,
    },
  };
  return snsAxiosClient(options).patch(
    formatString(get(environmentVariables, 'UPDATE_DELIVERY_INSTRUCTIONS', 'update_delivery_instructions'), {
      UUID: get(user, 'UUID'),
    }),
    deliveryInstructions,
  );
}

export default updateDeliveryInstructionsService;
